import SBPhoneInput from '@modules/sb-antd-phone-input/SBPhoneInput'
import { useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { formatPhoneNumberToE164FromPhoneInput } from '@utils/PhoneFormatter'
import { isE164Phone, requiredRule } from '@utils/rules'
import { Alert, Flex, Form } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import TextArea from 'antd/es/input/TextArea'
import { FC } from 'react'

interface Props {}

const BookingConnectorWhatsappSection: FC<Props> = ({}) => {
  const venue = useAppSelector(selectSelectedVenue())
  const formItemNameBase: NamePath = [
    'booking',
    'app',
    'connectors',
    'whatsapp',
  ]

  if (!venue) return <></>

  return (
    <Flex vertical style={{ padding: 20 }}>
      <Form.Item
        name={[...formItemNameBase, 'number']}
        label={'Phone number'}
        rules={[requiredRule(), isE164Phone()]}
        getValueFromEvent={formatPhoneNumberToE164FromPhoneInput}
      >
        <SBPhoneInput
          disableParentheses
          enableSearch
          sbInitialValue={venue.booking.app.connectors.whatsapp.number}
        />
      </Form.Item>
      <Form.Item
        name={[...formItemNameBase, 'message']}
        label={'Pre-fill message'}
        rules={[]}
      >
        <TextArea
          showCount
          maxLength={250}
          placeholder={`I want to book at ${venue.name} ...`}
        />
      </Form.Item>
      <Alert title="When the user clicks the Book button, it will open WhatsApp in a new conversation with the phone number just above. You can customize the pre-filled message, and the user can still edit it before sending. If the user doesn't have the WhatsApp app installed, they will be redirected to the store to download it." />
    </Flex>
  )
}

export { BookingConnectorWhatsappSection }
